import { notifyResponseError, success, error } from '../notification';
import request from '../axios';
import { API } from '../../constants';

export const fetchLunches = (year, month, username) =>
  request
    .get(`${API.LUNCHES}?year=${year}&month=${month}&username=${username}`)
    .then((res) => res.data)
    .catch((e) => {
      error('Errore', 'Impossibile caricare i pranzi');
      throw e;
    });

export const updateLunchOffered = (id, offered) =>
  request
    .put(`${API.LUNCHES}${id}/`, {
      offered,
    })
    .then((res) => {
      success('Esito', 'Aggiornamento eseguito con successo');
      return res.data;
    })
    .catch((e) => {
      notifyResponseError(e);
      throw e;
    });

export const getLunchStatus = (momentDate, username) =>
  request
    .get(
      `${API.LUNCHES}?username=${username}&year=${momentDate.format(
        'YYYY'
      )}&month=${momentDate.format('MM')}`
    )
    .then((res) => res.data)
    .catch((e) => {
      notifyResponseError(e);
      throw e;
    });

export const createLunchRecord = (date, offered, userId) =>
  request
    .post(`${API.LUNCHES}`, {
      date,
      offered,
      user: userId,
    })
    .then((res) => {
      success('Esito', 'Salvataggio riuscito');
      return res.data;
    })
    .catch((e) => {
      notifyResponseError(e);
      throw e;
    });
